import { useStyles } from "./SessionInfoStyles.css";
import AssociationLogo from "components/commons/utils/logo/AssociationLogo";
import { useIntl } from "react-intl";

const SessionInfo = ({ discipline, association, ageGroup, gender }) => {
    const classes = useStyles();

    const intl = useIntl();

    return (
        <div className={classes.associationDiscipline}>
            <div className={classes.logo}>
                <AssociationLogo association={association} height={60} width={60} />
            </div>
            <div className={classes.info}>
                {intl.formatMessage({ id: `app.ids.discipline.${discipline}` })}
                <span> - </span>
                {intl.formatMessage({ id: `app.ids.ageGroup.${ageGroup}` })}(
                {intl.formatMessage({ id: `app.ids.gender.${gender}` })})
            </div>
        </div>
    );
};

export default SessionInfo;
